import React from 'react'
import { IconButton, Tooltip } from '@mui/material'
import { FlightDeck } from 'src/components/FlightDeck/FlightDeck'
import styled from 'styled-components/macro'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import loadComponent from 'src/utils/loadMFE'
import { useSidebar } from '../SidebarContext'

const HeaderRoot = styled.div<{ $isOpen: boolean }>`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
    background: ${({ theme }) => theme.palette.background.paper};
`

const ToggleRow = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: ${({ theme }) => theme.spacing(0.5, 1, 0)};
`

const ContentRow = styled.div<{ $isOpen: boolean }>`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(1)};
    padding: ${({ theme, $isOpen }) => ($isOpen ? theme.spacing(1, 2, 2) : theme.spacing(1, 1, 2))};
    min-height: 56px;
`

const UserInfoContainer = styled.div<{ $isOpen: boolean }>`
    flex: 1;
    min-width: 0;
    overflow: hidden;
    opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
    width: ${({ $isOpen }) => ($isOpen ? 'auto' : 0)};
    transition: opacity 0.2s ease;
`

const FlightDeckContainer = styled.div`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`

const ToggleButton = styled(IconButton)`
    width: 28px;
    height: 28px;
    color: ${({ theme }) => theme.palette.text.secondary};
    border: 1px solid ${({ theme }) => theme.palette.divider};
    background: ${({ theme }) => theme.palette.background.paper};

    &:hover {
        background: ${({ theme }) => theme.palette.action.hover};
        color: ${({ theme }) => theme.palette.text.primary};
    }
`

const SidebarUserInfo = React.lazy(() => loadComponent('orga', 'SidebarUserInfo'))

export default function SidebarHeader() {
    const { isOpen, toggle } = useSidebar()

    return (
        <HeaderRoot $isOpen={isOpen}>
            <ToggleRow>
                <Tooltip title={isOpen ? 'Sidebar einklappen' : 'Sidebar ausklappen'} placement="right">
                    <ToggleButton size="small" onClick={toggle} aria-label="toggle sidebar">
                        {isOpen ? <ChevronLeftIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
                    </ToggleButton>
                </Tooltip>
            </ToggleRow>
            <ContentRow $isOpen={isOpen}>
                <UserInfoContainer $isOpen={isOpen}>
                    <SidebarUserInfo />
                </UserInfoContainer>
                <FlightDeckContainer>
                    <FlightDeck />
                </FlightDeckContainer>
            </ContentRow>
        </HeaderRoot>
    )
}
